export const embedCodePattern =
	/<(\"[^\"]*\"|'[^']*'|[^'\">])([a-zA-Z]+)(?:[^>]*[^/]*)((<\/)\w+(>))?>$/;
export const videoUrlPattern =
	/^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)+(\.(mp4|mkv|flv|3gp|avi|mov|webm))?$/;
// Bare VdoCipher video id as shown in their dashboard.
export const vdocipherIdPattern = /^[a-f0-9]{32}$/i;

// The LINK tab accepts a provider URL or a bare VdoCipher video id.
export const isValidVideoSource = (value: string) =>
	videoUrlPattern.test(value) || vdocipherIdPattern.test(value.trim());
